import React from 'react';
import { FadeIn } from './Shared';
import { Check, X, Sparkles } from 'lucide-react';
export function Audience() {
  return <section className="py-24 bg-white" data-id="element-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-9">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-24" data-id="element-10">
          {/* Who this is for */}
          <FadeIn data-id="element-11">
            <div className="bg-brand-cream rounded-3xl p-8 md:p-12 h-full" data-id="element-12">
              <h3 className="text-2xl font-heading text-brand-teal mb-8 flex items-center" data-id="element-13">
                <Check className="w-8 h-8 text-brand-teal mr-3" data-id="element-14" />
                Este protocolo ES para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-15">
                <li className="flex items-start" data-id="element-16">
                  <div className="w-2 h-2 rounded-full bg-brand-teal mt-2 mr-4 shrink-0" data-id="element-17"></div>
                  <p className="text-brand-charcoal/80" data-id="element-18">
                    Mujeres latinas en USA que se sienten perdidas tras una
                    separación de una pareja de la que dependían emocional o
                    económicamente.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-19">
                  <div className="w-2 h-2 rounded-full bg-brand-teal mt-2 mr-4 shrink-0" data-id="element-20"></div>
                  <p className="text-brand-charcoal/80" data-id="element-21">
                    Aquellas que sienten una necesidad compulsiva de contactar a
                    su ex a pesar de saber que les hace daño.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-22">
                  <div className="w-2 h-2 rounded-full bg-brand-teal mt-2 mr-4 shrink-0" data-id="element-23"></div>
                  <p className="text-brand-charcoal/80" data-id="element-24">
                    Mujeres que quieren dejar de sentirse víctimas y necesitan
                    un plan de acción concreto y estratégico.
                  </p>
                </li>
              </ul>
            </div>
          </FadeIn>

          {/* Who this is NOT for */}
          <FadeIn delay={0.2} data-id="element-25">
            <div className="bg-brand-rose/10 rounded-3xl p-8 md:p-12 h-full" data-id="element-26">
              <h3 className="text-2xl font-heading text-brand-rose mb-8 flex items-center" data-id="element-27">
                <X className="w-8 h-8 text-brand-rose mr-3" data-id="element-28" />
                Este protocolo NO es para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-29">
                <li className="flex items-start" data-id="element-30">
                  <div className="w-2 h-2 rounded-full bg-brand-rose mt-2 mr-4 shrink-0" data-id="element-31"></div>
                  <p className="text-brand-charcoal/80" data-id="element-32">
                    Mujeres que buscan trucos psicológicos para "recuperar a su
                    ex" o darles celos.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-33">
                  <div className="w-2 h-2 rounded-full bg-brand-rose mt-2 mr-4 shrink-0" data-id="element-34"></div>
                  <p className="text-brand-charcoal/80" data-id="element-35">
                    Personas que no están dispuestas a ejecutar un contacto cero
                    radical por su propia salud mental.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-36">
                  <div className="w-2 h-2 rounded-full bg-brand-rose mt-2 mr-4 shrink-0" data-id="element-37"></div>
                  <p className="text-brand-charcoal/80" data-id="element-38">
                    Quienes buscan una solución mágica sin realizar el trabajo
                    de reconstrucción personal.
                  </p>
                </li>
              </ul>
            </div>
          </FadeIn>
        </div>

        {/* Proof / Believability */}
        <FadeIn data-id="element-39">
          <div className="max-w-3xl mx-auto text-center" data-id="element-40">
            <Sparkles className="w-12 h-12 text-brand-gold mx-auto mb-6" data-id="element-41" />
            <p className="text-2xl md:text-3xl font-heading text-brand-teal leading-relaxed" data-id="element-42">
              En 7 días, el ruido mental constante empezará a disminuir. Al
              llegar al día 21, habrás sustituido el hábito de mirar hacia atrás
              por la inercia de moverte hacia tus propios objetivos.
            </p>
            <p className="mt-6 text-xl text-brand-charcoal/60 italic" data-id="element-43">
              No es magia, es neurobiología aplicada a tu libertad.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}